import { render, staticRenderFns } from "./myClass.vue?vue&type=template&id=10554b9e&"
import script from "./myClass.vue?vue&type=script&lang=js&"
export * from "./myClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports